'use client';

import { useReactiveVar } from '@apollo/client';
import { currentPreviewEnvironment } from '@frameio/graphql-client/apollo/links/PreviewEnvLink';
import { getDevFlag } from '@frameio/shared/dev-flags';
import { AlertBanner, theme } from '@frameio/vapor';
import { BannerWrapper } from './BannerWrapper';

export function PreviewEnvironmentBanner() {
  const prPrefix = 'pr-';
  const previewEnvironment = useReactiveVar(currentPreviewEnvironment);
  const enabledViaDevFlag = getDevFlag('BE_PREVIEW_ENVIRONMENT');
  const prNumber = previewEnvironment?.split(prPrefix)[1];
  const previewUrl =
    prNumber && `https://github.com/Frameio/massdriver/pull/${prNumber}`;
  const shouldShow =
    previewEnvironment?.startsWith(prPrefix) && enabledViaDevFlag;
  const finalRequestHeader = `massdriver-${previewEnvironment}`;

  if (!shouldShow) return null;

  return (
    <BannerWrapper>
      <AlertBanner
        details={
          <a
            href={previewUrl}
            rel="noreferrer"
            style={{
              color: theme.colors.text.link,
            }}
            target="_blank"
          >
            {finalRequestHeader}
          </a>
        }
        title={"You're using a backend preview environment:"}
      />
    </BannerWrapper>
  );
}
